import React, { createContext } from "react";
import { emptyPatientContext } from "../models/patient";

export const PatientContext = createContext<PatientContextType | null>(null);
export const PatientDispatchContext = createContext<
  React.ActionDispatch<[action: Action]>
>(() => void 0);

type Action =
  | { type: "set"; patient: PatientContextType }
  | { type: "update"; patient: Partial<PatientContextType> }
  | { type: "encounterUpdate"; encounter: PatientEncounterSummary }
  | { type: "patientAttributeUpdate"; attributes: PatientAttribute[] }
  | { type: "forceTableRefresh" }
  | { type: "delete" };

export function patientReducer(
  prevState: PatientContextType,
  action: Action,
): PatientContextType {
  switch (action.type) {
    case "set": {
      return { ...action.patient, forceTableUpdate: 0 };
    }
    case "update": {
      return { ...prevState, ...action.patient };
    }
    case "encounterUpdate": {
      const newEncounters: PatientEncounterSummary[] = [];
      prevState.encounters?.forEach((e) => {
        if (e.id === action.encounter.id) {
          newEncounters.push(action.encounter);
        } else {
          newEncounters.push(e);
        }
      });
      return { ...prevState, encounters: newEncounters };
    }
    case "patientAttributeUpdate": {
      return {
        ...prevState,
        attributes: action.attributes,
        attributesUpdated: true,
      };
    }
    case "forceTableRefresh":
      return {
        ...prevState,
        forceTableUpdate: prevState.forceTableUpdate + 1,
      };
    default:
    case "delete": {
      return emptyPatientContext;
    }
  }
}
